export default __webpack_public_path__ + "fonts/32B097_2_0.ttf";